import { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import debounce from 'debounce';

import { comparisonOptionNames } from '../../models';

class StateToUrl extends Component {
  constructor(props) {
    super(props);

    this.update = debounce(this.updateUrl, 200);
  }

  componentDidUpdate() {
    this.update();
  }

  updateUrl = () => {
    const {
      history, selectedLocation, selectedReport, dateRange, filterOptions, comparisonDateRanges, inApp, location,
    } = this.props;

    if (inApp) {
      return;
    }

    const validComparisonDateRanges = comparisonDateRanges.filter(cdr => cdr.option !== comparisonOptionNames.none);

    const comparisonDateRangesString = validComparisonDateRanges.length > 0 ? JSON.stringify(validComparisonDateRanges) : null;

    const queryObject = queryString.stringify({
      locationId: selectedLocation ? selectedLocation.id : null,
      reportId: selectedReport ? selectedReport.reportID : null,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      comparisonDateRanges: comparisonDateRangesString,
      in_app: inApp,
      ...filterOptions,
    }, { arrayFormat: 'bracket', sort: false, parseBooleans: true });

    if (`?${queryObject}` !== location.search) {
      history.push(`?${queryObject}`);
    }
  };

  render() {
    return null;
  }
}

StateToUrl.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  dateRange: PropTypes.object,
  selectedLocation: PropTypes.object,
  selectedReport: PropTypes.object,
  filterOptions: PropTypes.object,
  comparisonDateRanges: PropTypes.array,
  inApp: PropTypes.bool,
};

StateToUrl.defaultProps = {
  dateRange: null,
  selectedLocation: null,
  selectedReport: null,
  filterOptions: null,
  comparisonDateRanges: [],
  inApp: null,
};

export default StateToUrl;
